import { isEqual } from "lodash";
import { useState } from "react";

import { OUTGOING_MAIL_STATUSES, MAIL_CLASSIFICATION_STATUS } from "src/utils/constants/constants";
import { OutgoingMailCombinedStatusQuickFilter } from "./interfaces";

export const useOutgoingMailCombinedStatusQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<OutgoingMailCombinedStatusQuickFilter>({
    outgoingMailCombinedStatus: {
      statusIds: [OUTGOING_MAIL_STATUSES.Pending.id, MAIL_CLASSIFICATION_STATUS.ToBeClassified.id],
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof OutgoingMailCombinedStatusQuickFilter,
    value: OutgoingMailCombinedStatusQuickFilter["outgoingMailCombinedStatus"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    outgoingMailCombinedStatusQuickFilter: quickFilter,
    setOutgoingMailCombinedStatusQuickFilter: handleChangeQuickFilter,
  };
};
